/**
 * This creates a input type-view.
 *
 * ### USAGE:
 *
 *  helloFieldModel = new Backbone.Model({
 *    type: 'textarea',
 *    placeholder: 'This is a textarea',
 *    value: 'Hello, Field'
 *  });
 *
 * var helloField = new CreateField({model: helloFieldModel});
 *
 * returns Backbone.View
 *
 * ### EXTEND WITH CUSTOM TYPES
 *
 * // make a copy of the constructor
 * var ExtendedCreateField = CreateField.extend();
 *
 * _.extend(ExtendedCreateField.prototope.types, {
 *   customType: function(field) {
 *     return new CustomFieldView({model: field});
 *   }
 * })
 *
 * var customField = new ExtendedCreateField({model: customFieldModel});
 *
 */


define('modules/form/CreateField',['backbone', '_',

  'modules/form/readonly_view',
  'modules/form/input_view',
  'modules/form/range_view',
  'modules/form/textarea_view',
  'modules/form/rtftextarea_view',
  'modules/form/checkbox_view',
  'modules/form/radio_view',
  'modules/form/select_view',
  'modules/form/divider_view',
  'modules/form/multisearchabletext_view',
  'modules/form/status_view',
  'modules/form/info_view',
  'modules/form/background_view',
  'modules/form/image_view',
	'modules/form/media_view',
	'modules/form/switch_view'

], function (Backbone, _, ReadonlyView, InputView, RangeView, TextareaView, RTFtextareaView, CheckboxView, RadioView, SelectView, DividerView, MultisearchabletextView, StatusView, InfoView, BackgroundView, ImageView, MediaView, SwitchView) {
  'use strict';
  var CreateField = function (options) {
    this.field = options.model;
    this.dataModel = options.dataModel || new Backbone.Model();
    this.type = this.field.get('type') || 'default';
    return this.initialize.apply(this, arguments);
  };

  CreateField.extend = Backbone.Model.extend;

  _.extend(CreateField.prototype, {
    initialize: function (field) {
      return (this.types[this.type] || this.types['standard'])(this.field, this.dataModel);
    },
    types: {
      tags: function (field, dataModel) {
        return new SelectView({ model: field, dataModel: dataModel });
      },
      select: function (field, dataModel) {
        return new SelectView({ model: field, dataModel: dataModel });
      },
      checkbox: function (field, dataModel) {
        return new CheckboxView({ model: field, dataModel: dataModel });
      },
      radio: function (field, dataModel) {
        return new RadioView({ model: field, dataModel: dataModel });
      },
      status: function (field, dataModel) {
        return new StatusView({ model: field, dataModel: dataModel });
      },
      readonly: function (field) {
        return new ReadonlyView({ model: field });
      },
      text: function (field, dataModel) {
        return new InputView({ model: field, dataModel: dataModel });
      },
      range: function (field, dataModel) {
        return new RangeView({ model: field, dataModel: dataModel });
      },
      textarea: function (field, dataModel) {
        return new TextareaView({ model: field, dataModel: dataModel });
      },
      rtftextarea: function (field, dataModel) {
        return new RTFtextareaView({ model: field, dataModel: dataModel });
      },
      info: function (field) {
        return new InfoView({ model: field });
      },
      background: function (field) {
        return new BackgroundView({ model: field });
      },
      image: function (field, dataModel) {
        return new ImageView({ model: field, dataModel: dataModel });
      },
      media: function (field, dataModel) {
        return new MediaView({ model: field, dataModel: dataModel });
      },
      divider: function (field, dataModel) {
        return new DividerView({ model: field, dataModel: dataModel });
      },
      multisearchabletext: function (field, dataModel) {
        return new MultisearchabletextView({ model: field, dataModel: dataModel });
      },
      switch: function (field, dataModel) {
        return new SwitchView({model: field, dataModel: dataModel});
      },
      standard: function (field, dataModel) {
        return new InputView({ model: field, dataModel: dataModel });
      }
    }

  });

  return CreateField;
});

